import type { ClientePerfil, MedidasCorporales, CombinacionPersonalizada } from '../../../../hooks/useAdminClientePerfil';

export const emptyMedidas: MedidasCorporales = {
  altura: '',
  talla: '',
  contorno_pecho: '',
  contorno_cintura: '',
  contorno_cadera: '',
  contorno_brazo: '',
  largo_pierna: '',
  notas_medidas: '',
  tallas_por_marca: {},
};

export function buildPerfilDraft(
  dbPerfil: ClientePerfil | null,
  palette: string[],
  tonoPiel: string,
  estiloPersonal: string,
  notas: string,
  ocasiones: string[],
  prendasEvitar: string[],
  medidas: MedidasCorporales | null,
  combinaciones: CombinacionPersonalizada[]
): ClientePerfil {
  return {
    id: dbPerfil?.id ?? 0,
    cliente_id: dbPerfil?.cliente_id ?? 0,
    paleta_colores: palette,
    tono_piel: tonoPiel || dbPerfil?.tono_piel || null,
    estilo_personal: estiloPersonal || dbPerfil?.estilo_personal || null,
    notas_estilista: notas || dbPerfil?.notas_estilista || null,
    ocasiones_preferidas: ocasiones.length > 0 ? ocasiones : (dbPerfil?.ocasiones_preferidas ?? null),
    prendas_a_evitar: prendasEvitar.length > 0 ? prendasEvitar : (dbPerfil?.prendas_a_evitar ?? null),
    medidas_corporales: medidas || dbPerfil?.medidas_corporales || null,
    looks_favoritos: dbPerfil?.looks_favoritos ?? null,
    combinaciones_personalizadas: combinaciones.length > 0 ? combinaciones : (dbPerfil?.combinaciones_personalizadas ?? null),
    created_at: dbPerfil?.created_at,
    updated_at: dbPerfil?.updated_at,
  };
}